import * as React from "react";
const SvgSettings24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "black",
        viewBox: "0 0 24 24"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M9.44.2h5.12l.744 2.678c.276.1.546.212.81.336l2.42-1.368 3.62 3.62-1.367 2.42c.123.264.236.534.335.81l2.678.744v5.12l-2.678.744c-.1.276-.212.546-.335.81l1.367 2.42-3.62 3.62-2.42-1.367a9.632 9.632 0 0 1-.81.336L14.56 23.8H9.44l-.744-2.677a9.634 9.634 0 0 1-.81-.336l-2.42 1.367-3.62-3.62 1.367-2.42a9.645 9.645 0 0 1-.336-.81L.2 14.56V9.44l2.677-.744c.1-.276.213-.546.336-.81l-1.367-2.42 3.62-3.62 2.42 1.368c.264-.124.534-.236.81-.336L9.44.2Zm1.52 2-.628 2.26-.53.158a7.647 7.647 0 0 0-1.466.608l-.487.264-2.043-1.155-1.471 1.47L5.49 7.85l-.264.487c-.25.462-.455.953-.608 1.466l-.158.53-2.26.628v2.08l2.26.628.158.53c.153.513.357 1.004.608 1.467l.264.486-1.155 2.044 1.47 1.47L7.85 18.51l.487.264c.462.251.953.456 1.466.608l.53.158.628 2.26h2.08l.628-2.26.53-.158a7.648 7.648 0 0 0 1.466-.608l.487-.264 2.043 1.155 1.47-1.47-1.154-2.044.264-.486a7.75 7.75 0 0 0 .608-1.467l.158-.53 2.26-.628v-2.08l-2.26-.628-.158-.53a7.648 7.648 0 0 0-.608-1.466l-.264-.487 1.155-2.043-1.47-1.47L16.15 5.49l-.487-.264a7.646 7.646 0 0 0-1.466-.608l-.53-.157-.628-2.26h-2.08ZM12 9.4a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2ZM7.4 12a4.6 4.6 0 1 1 9.2 0 4.6 4.6 0 0 1-9.2 0Z",
      clipRule: "evenodd"
    })
  );
export default SvgSettings24Px;
